import { AdContainerStore } from '../../../../common/js/stores/ad-container.store';
import { RootStore } from '../../../../common/js/stores/root.store';
import { checkAndSendNoUserIdTrack } from '../../../../common/js/TrackAnalyticsHelper';
import { reaction } from '../../../../common/js/utils/preact-utils';

export class NoUserHandler {
  adContainerStore: AdContainerStore;

  constructor({ adContainerStore }: RootStore) {
    this.adContainerStore = adContainerStore;
    let unsubscribeReaction: () => void;

    unsubscribeReaction = reaction(
      () => this.adContainerStore.isViewable.value,
      (isViewable: boolean) => {
        if (!isViewable) return;

        // TODO: move some logic from analyticsServce.checkAndSendNoUserIdTrack to here
        // create AnalyticsService instance and use it directly
        // check if no user id track is still needed
        checkAndSendNoUserIdTrack();
        unsubscribeReaction && unsubscribeReaction();
      },
      true
    );
  }
}
